import { GuestSelectorDialog } from "./GuestSelectorDialog";
import { connect } from "../connect-with-dialog";
import { sum } from "@escapio/shared/util/array";
import { html, render } from "lit-html";
import { stateful } from "@escapio/shared/components/element-builder";

customElements.define(
	"esc-guest-selector-input",
	stateful(
		class extends connect(GuestSelectorDialog, HTMLElement) {
			static getInitialState() {
				return {
					rooms: null,
				};
			}

			connectedCallback() {
				this.addEventListener("DialogClosed", () => this.update());
			}

			onDialogChanged({ detail }) {
				this.renderGuests(detail.rooms);
			}

			onDialogConfirm({ detail }) {
				this.dispatchEvent(new CustomEvent("confirm", { detail }));
			}

			render() {
				this.renderGuests(this.rooms);
			}

			renderGuests(rooms) {
				const numGuests = sum(
					rooms.map(({ adults, children }) => adults + children.length),
				);
				render(
					html`<div class="input-with-icon--addon">
							<span class="fa fa-users"></span>
						</div>
						<div class="input">${numGuests}</div>`,
					this,
					{
						host: this,
					},
				);
			}

			getDialogParams() {
				return [this.rooms, this.getAttribute("max-guests")];
			}
		},
	),
);
